import {dom} from 'core-utils';
import { signal } from 'core-application';

/**
 * Object holding all private functions
 */
var __ = {};

var _start,
	_requestId,
	_performanceVideo,
	_performanceTestTime = 1000,
	_numberUpdates = 0,
	_minFPS = 15,
	_maxTests = 5,
	_currentTestCount = 0,
	_frameToggle = 0;

/**
* @function init
* @description public initialize method
* @returns {undefined}
*/
function init() {
	__.handleVideoPerformanceTest();
}

/**
* @description private function returning the current count of the testing
* @return {Number} the current count of testings
*/
__.getCurrentTestCount = function() {
	return _currentTestCount;
};
/**
 * @description private function handling the testing of the video performance
 * @return {undefined}
 */
__.handleVideoPerformanceTest = function() {
	var lastFps = __.getLastFPS();
	if (!!lastFps && lastFps >= _minFPS) {
		__.emitVIdeoPerformance(lastFps);
	} else {
		__.setTestVideo();
		__.addTestVideoEvents();
	}
};

/**
 * @description private function getting the last value for fps
 * @param {Number} fps - last frames per second
 * @returns {undefined}
 */
__.storeLastFPS = function(fps) {
	if (!!fps && fps >= 0) {
		localStorage.setItem('lastVideoFps', fps);
	}
};

/**
 * @description private function getting the last value for fps
 * @returns {Number} last frames per second
 */
__.getLastFPS = function() {
	var fps = parseInt(localStorage.getItem('lastVideoFps'), 10);
	return !!fps ? fps : 0;
};

/**
 * @description private function setting up the testvideo
 * @returns {undefined}
 */
__.setTestVideo = function(){
	_performanceVideo = document.createElement('video');
	_performanceVideo.setAttribute('data-video-notracking', 'true');
	_performanceVideo.src = "data:video/mp4;base64,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";
	_performanceVideo.autoplay = true; // needed for safari ios in order to trigger the canplay event
	_performanceVideo.style.display = 'none';
	document.body.appendChild(_performanceVideo);
};

/**
 * @description private function adding events to the test video
 * @returns {undefined}
 */
__.addTestVideoEvents = function() {
	setTimeout(function(){
		if (_performanceVideo.readyState >= 4) {
			__.checkVideoPerformance();
		} else {
			_performanceVideo.addEventListener('canplay', __.checkVideoPerformance);
		}
	}, 100);
};

/**
 * @description private function emitting the performance event
 * @param {Number} fps - the frames per second to emit
 * @returns {undefined}
 */
__.emitVIdeoPerformance = function(fps) {
	var emitFps = (!!fps && fps >= 0) ? fps : 0;
	signal.getEmitter().emit('video_performance', {'fps' : emitFps});
};

/**
 * @description private function returning the average fps rate
 * @param {Timestamp} start - starttime of the test
 * @param {Number} numberUpdates - the number of timeupdates
 * @returns {Float} fps
 */
__.getAverageFPS = function(start, numberUpdates) {
	if (!start || !numberUpdates || start <=0 || numberUpdates <=0) {
		return 0;
	}
	return 1000 / Math.round((new Date().getTime() - start) / numberUpdates);
};
/**
 * @description private function toggling the frames of a video
 * @returns {undefined}
 */
__.toggleVideoFrames = function() {
	_performanceVideo.currentTime = _frameToggle;
	if (_frameToggle < _performanceVideo.duration) {
		_frameToggle += 0.1;
	} else {
		_frameToggle = 0;
	}
	_requestId = requestAnimationFrame(__.toggleVideoFrames);
};
/**
 * @description private function checking the video performance by creating a video element
 * and checking on the preiod of time between timeupdates *
 * @returns {undefined}
 */
__.checkVideoPerformance = function() {
	_currentTestCount++;
	_performanceVideo.removeEventListener('canplay', __.checkVideoPerformance);
	_start = new Date().getTime();
	_performanceVideo.addEventListener('timeupdate', __.increaseNumberUpdates);
	_requestId = requestAnimationFrame(__.toggleVideoFrames);
	setTimeout(__.handleResult, _performanceTestTime);
};

/**
 * @description private function increasing the update count
 * @returns {undefined}
 */
__.increaseNumberUpdates = function() {
	_numberUpdates++;
};

/**
 * @description private function handling the result of the performance check
 * @returns {undefined}
 */
__.handleResult = function() {
	var fps = __.getAverageFPS(_start, _numberUpdates),
	currentTestCount = __.getCurrentTestCount();

	// store fps
	if (fps >= _minFPS) {
		__.storeLastFPS(fps);
	}

	// emit first result
	if (currentTestCount === 1) {
		cancelAnimationFrame(_requestId);
		document.body.removeChild(_performanceVideo);
		__.emitVIdeoPerformance(fps);
	}

	// continue testing
	if (fps < _minFPS && currentTestCount < _maxTests) {
		_numberUpdates = 0;
		__.checkVideoPerformance();
	}
};

dom.handleDocumentReady(function() {
	init();
});

export { __, init };